import './assets/base.css'
import './assets/reset.css'

import { router } from './router'

import naive from 'naive-ui'
import { createApp } from 'vue'
import App from './App.vue'
import { installLocalVirtualFileFetch } from './utils/localVirtualFiles'

installLocalVirtualFileFetch()

const app = createApp(App)
app.use(naive)
app.use(router)
app.mount('#app')
